export const SCREENING_QUESTION_TEMPLATES = [
  {
    id: "background_check",
    category: "Background Check",
    questionTemplate:
      "Are you willing to undergo a background check, in accordance with local law/regulations?",
    type: "Single Select",
    subQuestion: ["Yes", "No"],
    idealAnswer: "Yes",
    idealAnswerType: "yes_no",
    isMultiAdd: false,
    placeholders: [],
  },
  {
    id: "education",
    category: "Education",
    questionTemplate:
      "Have you completed the following level of education: [Degree]?",
    type: "Single Select",
    subQuestion: ["Yes", "No"],
    idealAnswer: "Yes",
    idealAnswerType: "yes_no",
    isMultiAdd: false,
    placeholders: [{ key: "Degree", label: "Degree" }],
  },
  {
    id: "expertise_with_skill",
    category: "Expertise with Skill",
    questionTemplate:
      "How many years of work experience do you have with [Skill]?",
    type: "Short Text",
    subQuestion: null,
    idealAnswer: "1",
    idealAnswerType: "minimum_number",
    isMultiAdd: true,
    placeholders: [{ key: "Skill", label: "Skill" }],
  },
  {
    id: "hybrid_work",
    category: "Hybrid Work",
    questionTemplate: "Are you comfortable working in a hybrid setting?",
    type: "Single Select",
    subQuestion: ["Yes", "No"],
    idealAnswer: "Yes",
    idealAnswerType: "yes_no",
    isMultiAdd: false,
    placeholders: [],
  },
  {
    id: "language",
    category: "Language",
    questionTemplate: "What is your level of proficiency in [Language]?",
    type: "Single Select",
    subQuestion: ["Beginner", "Intermediate", "Advanced", "Native/Fluent"],
    idealAnswer: "",
    idealAnswerType: "text",
    isMultiAdd: true,
    placeholders: [{ key: "Language", label: "Language" }],
  },
  {
    id: "location",
    category: "Location",
    questionTemplate: "Are you comfortable commuting to [Location]?",
    type: "Single Select",
    subQuestion: ["Yes", "No"],
    idealAnswer: "Yes",
    idealAnswerType: "yes_no",
    isMultiAdd: false,
    placeholders: [{ key: "Location", label: "Location" }],
  },
  {
    id: "onsite_work",
    category: "Onsite Work",
    questionTemplate: "Are you comfortable working on-site?",
    type: "Single Select",
    subQuestion: ["Yes", "No"],
    idealAnswer: "Yes",
    idealAnswerType: "yes_no",
    isMultiAdd: false,
    placeholders: [],
  },
  {
    id: "remote_work",
    category: "Remote Work",
    questionTemplate: "Are you comfortable working remotely?",
    type: "Single Select",
    subQuestion: ["Yes", "No"],
    idealAnswer: "Yes",
    idealAnswerType: "yes_no",
    isMultiAdd: false,
    placeholders: [],
  },
  {
    id: "urgent_hiring",
    category: "Urgent Hiring Need",
    questionTemplate: "Can you start immediately?",
    type: "Single Select",
    subQuestion: ["Yes", "No"],
    idealAnswer: "Yes",
    idealAnswerType: "yes_no",
    isMultiAdd: false,
    placeholders: [],
  },
  {
    id: "work_authorization",
    category: "Work Authorization",
    questionTemplate: "Are you legally authorized to work in [Country]?",
    type: "Single Select",
    subQuestion: ["Yes", "No"],
    idealAnswer: "Yes",
    idealAnswerType: "yes_no",
    isMultiAdd: false,
    placeholders: [{ key: "Country", label: "Country" }],
  },
  {
    id: "work_experience",
    category: "Work Experience",
    questionTemplate: "How many years of work experience do you have?",
    type: "Short Text",
    subQuestion: null,
    idealAnswer: "1",
    idealAnswerType: "minimum_number",
    isMultiAdd: false,
    placeholders: [],
  },
  {
    id: "custom",
    category: "Custom Question",
    questionTemplate: "",
    type: "",
    subQuestion: null,
    idealAnswer: "",
    idealAnswerType: null,
    isMultiAdd: false,
    placeholders: [],
  },
];
